/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosAddressSummaryInfo = {
    ADT: AptosAddressSummaryInfo.ADT;
    ADDR: string;
    NN: string;
    SB: string;
};

export namespace AptosAddressSummaryInfo {

    export enum ADT {
        EOA = 'EOA',
        CA = 'CA',
        OBJECT = 'OBJECT',
    }


}

